var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawDestinationFkst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1033.241,
    height: 835.664,
    viewBox: "0 0 1033.241 835.664",
    xmlnxlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-368 -122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145-825",
    "data-name": "Path 145",
    d: "M691.776,147.5H430.193a77.484,77.484,0,0,0-77.4,77.4v23.644a3.592,3.592,0,0,0-4.546,3.508v18.182a3.593,3.593,0,0,0,4.546,3.508V301.27a3.592,3.592,0,0,0-4.546,3.508v45.456a3.592,3.592,0,0,0,4.546,3.508v16.621a3.592,3.592,0,0,0-4.546,3.508v45.456a3.592,3.592,0,0,0,4.546,3.508V902.856a77.485,77.485,0,0,0,77.4,77.4H691.776a77.484,77.484,0,0,0,77.4-77.4V224.9a77.484,77.484,0,0,0-77.4-77.4Zm61.033,755.356a61.1,61.1,0,0,1-61.033,61.033H430.193a61.1,61.1,0,0,1-61.033-61.033V224.9a61.1,61.1,0,0,1,61.033-61.033H691.776A61.1,61.1,0,0,1,752.809,224.9Z",
    transform: "translate(264.054 -25.5)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146-826",
    "data-name": "Path 146",
    d: "M688.514,970.972H426.931a70.2,70.2,0,0,1-70.124-70.124V222.889a70.2,70.2,0,0,1,70.124-70.124H688.514a70.2,70.2,0,0,1,70.124,70.124V900.848a70.2,70.2,0,0,1-70.124,70.124Z",
    transform: "translate(267.316 -23.492)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147-827",
    "data-name": "Path 147",
    d: "M690.461,957.051H415.95a47.35,47.35,0,0,1-47.3-47.3v-701.8a47.349,47.349,0,0,1,47.3-47.3h35.8a7.826,7.826,0,0,1,7.817,7.817,23.119,23.119,0,0,0,23.093,23.093H620.115a23.119,23.119,0,0,0,23.093-23.093,7.826,7.826,0,0,1,7.817-7.817h39.436a47.349,47.349,0,0,1,47.3,47.3v701.8A47.349,47.349,0,0,1,690.461,957.051Z",
    transform: "translate(271.833 -20.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148-828",
    "data-name": "Path 148",
    d: "M520.859,174.189H488.13a3.636,3.636,0,0,1,0-7.273h32.728a3.636,3.636,0,1,1,0,7.273Z",
    transform: "translate(315.999 -18.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.818,
    cy: 1.818,
    r: 1.818,
    transform: "translate(857.767 151.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 387.15,
    height: 4.144,
    transform: "translate(631.283 282.226)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 387.15,
    height: 4.144,
    transform: "translate(631.283 365.102)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 387.15,
    height: 4.144,
    transform: "translate(631.283 536.379)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 387.15,
    height: 4.144,
    transform: "translate(631.283 707.655)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 387.15,
    height: 4.144,
    transform: "translate(631.283 841.638)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 4.144,
    height: 254.152,
    transform: "translate(908.296 284.298)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 4.144,
    height: 305.333,
    transform: "translate(714.485 538.376)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 293.033,
    height: 4.144,
    transform: "translate(716.557 622.131)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 4.144,
    height: 92.86,
    transform: "translate(908.742 843.709)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 269.881,
    height: 4.144,
    transform: "translate(639.797 452.437)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 4.144,
    height: 158.198,
    transform: "translate(692.337 139.163) rotate(-22.709)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 4.144,
    height: 113.206,
    transform: "translate(880.106 171.092)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149-829",
    "data-name": "Path 149",
    d: "M665.954,332.232c0,37.129-57.4,123.645-74.18,148.136a5.514,5.514,0,0,1-9.1,0c-16.776-24.491-74.18-111.007-74.18-148.136a78.732,78.732,0,0,1,157.464,0Z",
    transform: "translate(325.147 14.914)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 40.057,
    cy: 40.057,
    r: 40.057,
    transform: "translate(872.313 301.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 338.937,
    height: 4.144,
    transform: "translate(758.048 842.733) rotate(-63.412)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161-830",
    "data-name": "Path 161",
    d: "M1208.241,751.71a1.216,1.216,0,0,1-1.216,1.21H176.216a1.21,1.21,0,1,1,0-2.419h1030.81A1.216,1.216,0,0,1,1208.241,751.71Z",
    transform: "translate(193 204.573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 17.956,
    cy: 17.956,
    r: 17.956,
    transform: "translate(894.413 519.803)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162-831",
    "data-name": "Path 162",
    d: "M762.957,318.065c-7.5,9.995-40.427,21.689-49.889,24.893a1.856,1.856,0,0,1-2.451-1.839c.431-9.981,2.453-44.865,9.952-54.859a26.5,26.5,0,1,1,42.387,31.8Z",
    transform: "translate(402.21 23.364)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 13.481,
    cy: 13.481,
    r: 13.481,
    transform: "translate(1131.609 310.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 6.043,
    cy: 6.043,
    r: 6.043,
    transform: "translate(1099.43 370.794)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163-832",
    "data-name": "Path 163",
    d: "M294.341,510.177c11.035,16.86,10.683,73.207,10.344,89.314a2.992,2.992,0,0,1-4.134,2.706c-14.9-6.135-66.677-28.359-77.713-45.219a42.728,42.728,0,1,1,71.5-46.8Z",
    transform: "translate(213.577 105.404)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 21.739,
    cy: 21.739,
    r: 21.739,
    transform: "translate(448.785 614.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 9.745,
    cy: 9.745,
    r: 9.745,
    transform: "translate(519.075 715.792)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-6238.313 -1091.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 22.242,
    height: 28.597,
    transform: "translate(7286.338 1521.533) rotate(-2.221)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129-833",
    "data-name": "Path 129",
    d: "M591.71,375.659s-30.779-14.706-30.286-2.005,31.025,21.056,31.025,21.056Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130-834",
    "data-name": "Path 130",
    d: "M608.6,483.119s-14.521,35.542-19.886,61.189-13.536,60.942-3.026,85.974,40.392,98.6,40.7,106.537-2.559,16,3.791,15.752,40.907-11.126,42.31-15.95-11.79-17.032-11.79-17.032L628.117,617.506,662.107,551l24.516,99.215,4.8,123.828s23.567-7.274,26.988-1.047c0,0,10.559-14.719,11.9-21.131s-4.987-128.591-4.987-128.591,21.632-139.163,4.169-138.486S643.633,443.6,608.6,483.119Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131-835",
    "data-name": "Path 131",
    d: "M629.929,746.221s-16.109,35.6-17.635,37.252-12.023,17.956-4.085,17.648,26.68-8.984,40.476-22.239,31.984-36.219,30.335-37.745-12.947-5.858-12.947-5.858Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132-836",
    "data-name": "Path 132",
    d: "M694.292,765.984s-.972,15.937-3.9,22.41-2.559,16,5.378,15.691,28.453-4.283,28.453-4.283,1.218-9.587-.431-11.113-8.676-18.743-5.686-23.628S694.292,765.984,694.292,765.984Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133-837",
    "data-name": "Path 133",
    d: "M706.036,248.8s16.922,26.373,23.518,32.477-11.962,19.543-11.962,19.543l-33.215,4.468s.418-30.225-1.293-33.338S706.036,248.8,706.036,248.8Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134-838",
    "data-name": "Path 134",
    d: "M677.165,283.309s6.843,12.454,13.193,12.208,39.2-14.239,40.6-19.064,10.88,34.557,10.88,34.557L661.465,452.45,641.86,438.9l9.5-83.045,7.8-44.821Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135-839",
    "data-name": "Path 135",
    d: "M733.921,409.892c-3.206,6.707-5.208,13.7-4.931,20.86.012.318.025.635.053.952.761,14.693,6.173,31.686,8.115,44.044,1.409,8.865,1.008,15.336-4.18,16.856-12.577,3.668,1.834,6.289-46.826,22.485s-57.152,2.216-57.275-.959,6.891-27.3,5.242-28.822-23.074,19.974-29.548,17.045-.739-19.051-.739-19.051,14.583-33.954,14.275-41.892S640.2,396.037,640.2,396.037l15.234-99.167s5.858-12.947,13.734-14.842,14.411,2.621,14.411,2.621L670.4,313.78,656.492,365.2l2.326,18.989s16.17-34.016,26.791-47.147,33.264-44.218,33.264-44.218,5.286-17.837,1.3-23.168c-3.991-5.346,16.647-6.147,25.446,15.771,4.664,11.616,12.236,28.939,16.979,45.068,4.227,14.289,6.223,27.646,2.036,35.281C758.229,377.437,742.129,392.768,733.921,409.892Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136-840",
    "data-name": "Path 136",
    d: "M764.629,365.773c-6.4,11.664-22.5,27-30.708,44.119-2.144-7.723-4.759-15.715-4.759-15.715s-10.031-53.669,19.64-67.539a19.858,19.858,0,0,1,13.791,3.853C766.82,344.781,768.817,358.138,764.629,365.773Z",
    transform: "translate(6616.593 1245.092)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137-841",
    "data-name": "Path 137",
    d: "M646.843,362.391l-25.154,7.335-34.926,1.354-3.593,30.348,57.4,4.134S654.9,365.258,646.843,362.391Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138-842",
    "data-name": "Path 138",
    d: "M687.861,464.431s-33.652,5.583-25.971,15.71,37.492-.52,37.492-.52Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139-843",
    "data-name": "Path 139",
    d: "M729.044,431.7c.761,14.693,6.173,31.686,8.115,44.044-10.72,10.146-20.914,19.1-24.756,19.244-7.938.308-20.7-.787-25.4.985s-7.458-28.33-7.458-28.33,2.806-9.648,15.321-14.9C703.313,449.19,719.506,439.547,729.044,431.7Z",
    transform: "translate(6616.593 1245.092)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140-844",
    "data-name": "Path 140",
    d: "M748.433,317.113s26.865-4.222,25.414,40.353,2.832,73.027-7.973,81.4-45.9,46.3-53.84,46.606-20.7-.787-25.4.985-7.458-28.33-7.458-28.33,2.806-9.648,15.321-14.9,42-23.888,41.756-30.238-7.458-28.33-7.458-28.33S718.762,330.984,748.433,317.113Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 34.952,
    cy: 34.952,
    r: 34.952,
    transform: "translate(7263.986 1463.039)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141-845",
    "data-name": "Path 141",
    d: "M658.811,202.8a6.749,6.749,0,0,1-2.939,1.475,2.1,2.1,0,0,1-2.43-1.683c-.8,1.658-1.7,3.426-3.335,4.277s-4.157.137-4.393-1.689a7.706,7.706,0,0,1-1.774,3.744c-1.013.966-2.85,1.21-3.734.125.715,3.907.274,7.926.5,11.892s1.282,8.17,4.278,10.778c4.37,3.8,10.941,2.865,16.689,2.144a5.065,5.065,0,0,1,2.615.143c2.152.917,2.055,3.913,2.084,6.252a17.373,17.373,0,0,0,15.212,16.5,8.708,8.708,0,0,0,6.472-1.58c1.632-1.383,2.466-3.638,4.336-4.677,3.042-1.69,6.732.775,8.956,3.452s4.416,5.969,7.862,6.459c4.557.648,8.028-4,9.73-8.272a48.223,48.223,0,0,0-.958-37.47C708.467,193.929,675.964,190.648,658.811,202.8Z",
    transform: "translate(6616.593 1245.092)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDestinationFkst);
export default __webpack_public_path__ + "static/media/undraw_destination_fkst.2115cda66a23e26566ec46813dc98b9f.svg";
export { ForwardRef as ReactComponent };